import {BaseRequestOptions, Http, URLSearchParams} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';

@Injectable()
export class StatService {
    private ressourceInterneUrl = 'api/interne/stat';

    constructor(private http: Http) {}

    addStatValues (viewName: string, campaign: string): Observable <any> {
        let options = this.createRequestOption({'campaign': campaign});
        return this.http.get(`${this.ressourceInterneUrl}/${viewName}`, options).map((res: any) => {
            return res.json();
        });
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('campaign', req.campaign);
            options.search = params;
        }
        return options;
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/stat/stat.service.ts